import { render } from "./BrokersAccountsWidget.vue?vue&type=template&id=84e470c0&scoped=true&ts=true"
import script from "./BrokersAccountsWidget.vue?vue&type=script&lang=ts"
export * from "./BrokersAccountsWidget.vue?vue&type=script&lang=ts"

import "./BrokersAccountsWidget.vue?vue&type=style&index=0&id=84e470c0&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84e470c0"]])

export default __exports__